import { useAppDispatch, useAppSelector } from "@/hooks";
import {actions as reclamATCActions} from "../slices/reclamATC";
import { default as reclamATCService } from "../services/reclamATC";
import { useEffect, useState } from "react";
import { Tipus, Subtipus } from "../types/reclamATC";

const useReclamATCTipus = () => {

  const dispatch = useAppDispatch();

  const availableTipus = useAppSelector(state => state.reclamATC.availableTipus);
  const tipusState = useAppSelector(state => state.reclamATC.tipusState);
  const availableSubtipus = useAppSelector(state => state.reclamATC.availableSubtipus);
  const subtipusState = useAppSelector(state => state.reclamATC.subtipusState);

  const [selectedTipus, setSelectedTipus] = useState<Tipus>();
  const [selectedSubtipus, setSelectedSubtipus] = useState<Subtipus>();

  useEffect(() => {
    if (tipusState == "uninitialized") {
      fetchTipus();
    }
  }, []);

  useEffect(() => {
    if (selectedTipus) {
      fetchSubtipus(selectedTipus);
    }
  }, [selectedTipus]);

  const fetchTipus = () => {
    dispatch(reclamATCActions.fetchTipusRequested());
    reclamATCService.fetchATCTipus()
    .then(res => {
      dispatch(reclamATCActions.tipusReceived(res.promise.data));
    })
  }

  const fetchSubtipus = (tipus: string) => {
    dispatch(reclamATCActions.fetchSubtipusRequested());
    reclamATCService.fetchATCSubtipus(tipus)
    .then(res => {
      dispatch(reclamATCActions.subtipusReceived(res.promise.data));
    })
  }

  return {
    availableTipus,
    selectedTipus,
    tipusState,
    availableSubtipus,
    selectedSubtipus,
    subtipusState,
    setSelectedTipus,
    setSelectedSubtipus
  }
}

export default useReclamATCTipus;